//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'

//#endregion

import { default as commonModule, LoggerService } from './../common/common.module'
import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { Enums, Activity } from '../../models/common'
import { IUserSession, UserSession, ConfigHelper } from '../../helpers'
import { OpOperator } from '../../models/core'

import { default as SERVICES_MODULE_NAME } from './../../services/services.module'
import { PROVIDER_NAME as SYSTEM_SERVICE_PROVIDER_NAME, SystemServiceProvider, SystemService, $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SYSTEM_SERVICE_NAME } from '../../services/system'

import { SimcardCreateEditDirective } from './create-edit/simcards-create-edit.directive'
import { SimcardDetailsDirective } from './details/simcards-details.directive'
import { SimcardsController } from './simcards.controller'
import { USER_SESSION_SERVICE_NAME } from '../../services/user-session'

//#region Asset Imports

import * as TEMPLATE from './simcards.tpl.html'

//#endregion

// Consts

const CONTROLER_NAME: string = 'SimcardsController'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'simcardsCreateEdit'
const DETAILS_DIRECTIVE_NAME: string = 'simcardsDetails'
const MODULE_NAME: string = 'simax.simcards'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'Simcards'
const MENU_INDEX: number = 9
const STATE_NAME: string = 'simcards'
const STATE_URL: string = '/simcards'

// Consts End

// Setup 

const simaxModuleName: Enums.SimaxModuleName = Enums.SimaxModuleName.Sim_Card
const referenceType: Enums.ReferenceType = Enums.ReferenceType.IdSimCard
const module = angular.module(MODULE_NAME, [commonModule, apiModule, SERVICES_MODULE_NAME])

module.controller(CONTROLER_NAME, [$SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, 'logger', 'api', 'localDictionary', USER_SESSION_SERVICE_NAME, SYSTEM_SERVICE_NAME, (
    $scope,
    $state: StateService,
    $timeout,
    api: Api,
    logger: LoggerService,
    localDictionary: LocalDictionaryFactory,
    userSession: IUserSession,
    systemService: SystemService
) => new SimcardsController(
    $scope,
    $state,
    $timeout,
    api,
    logger,
    localDictionary,
    userSession,
    systemService,
    referenceType,
    simaxModuleName
)])

module.directive(DETAILS_DIRECTIVE_NAME, [() => new SimcardDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new SimcardCreateEditDirective()])

module.config(['$stateProvider', 'userSessionProvider', SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Sim_Card_IdSimCard',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.SIM_CARD_LIST)
                && !loggedOperator.hasPermission(Activity.SIM_CARD_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.SimCardModule)) {

                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.SIM_CARD),
                    'simcards',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    MENU_INDEX
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLER_NAME,
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

// Setup End

export default MODULE_NAME